
import { Vue, Component } from 'vue-property-decorator';
import { Toast, Popup } from 'vant';

Vue.use(Toast).use(Popup);

@Component
export default class Features extends Vue {
  showUdid: boolean = false;
  udid: string | number = '';
  created() {
    if (window.udid) {
      this.udid = window.udid;
    } else {
      this.udid = '请在上游app查看';
    }
  }
  onNavTo(path: string) {
    this.$router.push(path);
  }
  onClearLocalStorage() {
    localStorage.clear();
    Toast('清除缓存成功');
  }
}
